var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesSgcOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00361F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.90907,71.6656v145.74426H74.16483V102.07248c0.01905-16.78546,13.62169-30.38799,30.40715-30.40688 H219.90907 M236.6389,51.56923H104.57198c-27.89218-0.00016-50.50337,22.61081-50.50352,50.50298c0,0.00009,0,0.00018,0,0.00027 v132.06718c0,1.8593,1.50726,3.36653,3.36654,3.36653h179.2039c1.8593,0,3.36653-1.50723,3.36653-3.36653V54.93577 C240.00543,53.07648,238.4982,51.56923,236.6389,51.56923z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.83517,294.59009v115.33737c-0.01907,16.78546-13.62167,30.38797-30.40714,30.40689h-115.3371V294.59012 h145.74423 M454.56497,274.49374H275.36111c-1.85928,0-3.36655,1.50723-3.36655,3.36655v179.20392 c-0.00003,1.85928,1.50723,3.36658,3.36652,3.36658h0.00003h132.06693c27.89218,0.00015,50.50336-22.61084,50.50351-50.50296 c0-0.00012,0-0.00021,0-0.00031V277.86026c0-1.85928-1.50726-3.36655-3.36658-3.36655 C454.56497,274.49371,454.56497,274.49371,454.56497,274.49374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.83517,71.6656v145.74426H292.09094V71.6656H437.83517 M457.93155,51.56923H271.99457v185.937h185.93698 V51.56923z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.90907,294.59009v145.74426H74.16483V294.59012h145.74425 M240.00543,274.49374H54.06845v185.93698 h185.93698V274.49374z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesSgcOn);
export default __webpack_public_path__ + "static/media/services_sgc_on.ec8cb457ef4d3524adcd3395e8e9e248.svg";
export { ForwardRef as ReactComponent };